import { HelsenorgeHttpError, HelsenorgeProxyError } from '@helsenorge/framework-utils/hn-proxy-service';

export class UnknownErrorType {
  Error: string = '';
}
export type ProxyErrorResponse = {
  Code: string;
  Message: string;
  ErrorCategory: number;
};

export class TextMessage {
  Title: string = '';
  Body: string = '';
}

export const isProxyErrorResponse = (error: unknown): error is ProxyErrorResponse => {
  // Ensure error is an object and not null.
  if (typeof error !== 'object' || error === null) return false;

  // Cast error to a record to safely check properties.
  const e = error as Record<string, unknown>;

  // Check that each property exists and is of the expected type.
  return typeof e.Code === 'string' && typeof e.Message === 'string' && typeof e.ErrorCategory === 'number';
};

export const UNKNOWN_ERROR_CODE = 'UNKNOWN-ERROR-CODE';
export const transformFetchErrors = (
  error?: HelsenorgeProxyError | HelsenorgeHttpError | UnknownErrorType | unknown | TextMessage | ProxyErrorResponse
): ProxyErrorResponse | string => {
  let failure: ProxyErrorResponse = {
    Code: '',
    Message: '',
    ErrorCategory: 1,
  };
  if (isProxyErrorResponse(error)) {
    failure = error;
  } else {
    if (error instanceof HelsenorgeProxyError) {
      failure.Message = error.response.message;
      failure.Code = error.response.code;
      failure.ErrorCategory = error.response.errorCategory;
    }
    if (error instanceof HelsenorgeHttpError) {
      failure.Message = error.message;
      failure.Code = (error.response as { code: string })?.code || UNKNOWN_ERROR_CODE;
    }

    if (error instanceof UnknownErrorType) {
      failure.Message = error.Error;
      failure.Code = (error as { response?: { code?: string } })?.response?.code || UNKNOWN_ERROR_CODE;
    } else {
      failure.Message = 'Det har skjedd en teknisk feil. Prøv igjen senere.';
      failure.Code = (error as { response?: { code?: string } })?.response?.code || UNKNOWN_ERROR_CODE;
    }
  }
  return failure;
};
